import React from "react";
import Navbar from './Navbar'; 
import FaqQue from './FaqQue'; 
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';
import "./Faq.css"; // Import custom styles
import bannerImage from "../assets/img/faq_banner.png"; // Import your image path

const Faq = () => {
  return (
    <>
      <Navbar />
      
      {/* Main content area with background color */}
      <main className="main-content">
        <section
          className="Faq-container d-flex justify-content-center align-items-center text-center position-relative"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '500px',  // You can adjust the height here as needed
            color: '#fff',  // Set the text color to white for better contrast
          }}
        >
          
          <div className="overlay-text position-absolute top-50 start-50 translate-middle">
            <h1 className="morrestact-font text-black text-start">Frequently Asked Questions (FAQ)</h1>
            <p className="popins-font text-black text-start">
            Find answers to common questions about Breast Infrared, its benefits, process, and more.
            </p>
          </div>
        </section>
        
                {/* Faq Description */}
                <section className="Faq-description py-5">
          <div className="container">
            <p className="text-black">
            Breast Infrared is a safe, non-invasive imaging method used for early detection and monitoring of breast health. Below are answers to some frequently asked questions to help you understand the process better.
            </p>
          </div>
        </section>
        {/* FaqQue component below the banner */}
        <FaqQue />
        <ConsultationSection />
      <FooterSection />
      </main>
    </>
  );
};

export default Faq;
